import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Heart } from "lucide-react";

function Loader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F3F3F1]">
      <div className="animate-bounce bg-[#8B1E3F] nb-border nb-shadow p-4">
        <Heart className="w-8 h-8 text-white" fill="white" strokeWidth={2.5} />
      </div>
    </div>
  );
}

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
}
